import { inject } from '@angular/core';
import { Router, UrlSegment, UrlTree } from '@angular/router';
import { AuthService } from '../../infrastructure/shared/services/auth.service';

/**
 * Shared canMatch logic for the role areas. canMatch runs before AuthGuard, so an anonymous
 * visitor would otherwise fall through to the `**` wildcard and lose the deep link; send them
 * to login with a returnUrl instead. A signed-in user with a different role simply doesn't match.
 */
export function canMatchRole(hasRole: boolean, segments: UrlSegment[]): boolean | UrlTree {
  if (hasRole) return true;

  if (inject(AuthService).getToken) return false;

  const router = inject(Router);
  const returnUrl =
    router.currentNavigation()?.extractedUrl.toString() ??
    '/' + segments.map((s) => s.path).join('/');

  return router.createUrlTree(['/authentication/login'], { queryParams: { returnUrl } });
}
